(() => {
  'use strict';

  const SELECTOR = '.scroll-title-up';
  const VISIBLE_CLASS = 'is-title-visible';
  const INITIALIZED_ATTRIBUTE = 'data-title-reveal-initialized';

  document.documentElement.classList.add('title-reveal-enabled');

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  let observer = null;

  function createObserver() {
    if (observer || prefersReducedMotion.matches) {
      return observer;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const element = entry.target;
          const repeatAnimation =
            element.dataset.titleRepeat === 'true';

          if (entry.isIntersecting) {
            window.requestAnimationFrame(() => {
              element.classList.add(VISIBLE_CLASS);
            });

            /*
              Default behaviour: animation ek hi baar chalegi.

              Repeated animation ke liye title me add karein:
              data-title-repeat="true"
            */
            if (!repeatAnimation) {
              observer.unobserve(element);
            }
          } else if (repeatAnimation) {
            element.classList.remove(VISIBLE_CLASS);
          }
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    return observer;
  }

  function prepareElement(element) {
    if (
      !element ||
      element.hasAttribute(INITIALIZED_ATTRIBUTE)
    ) {
      return;
    }

    element.setAttribute(INITIALIZED_ATTRIBUTE, 'true');

    /*
      Optional animation delay:
      data-title-delay="200"

      Optional duration:
      data-title-duration="1000"

      Optional starting distance:
      data-title-distance="-80px"
    */
    const delay = Number(element.dataset.titleDelay);
    const duration = Number(element.dataset.titleDuration);
    const distance = element.dataset.titleDistance;

    if (Number.isFinite(delay) && delay >= 0) {
      element.style.setProperty(
        '--title-drop-delay',
        `${delay}ms`
      );
    }

    if (Number.isFinite(duration) && duration > 0) {
      element.style.setProperty(
        '--title-drop-duration',
        `${duration}ms`
      );
    }

    if (distance) {
      element.style.setProperty(
        '--title-drop-from',
        distance
      );
    }

    if (prefersReducedMotion.matches) {
      element.classList.add(VISIBLE_CLASS);
      return;
    }

    const titleObserver = createObserver();

    if (titleObserver) {
      titleObserver.observe(element);
    }
  }

  function initializeTitles(root = document) {
    const elements = [];

    if (
      root instanceof Element &&
      root.matches(SELECTOR)
    ) {
      elements.push(root);
    }

    if (
      root === document ||
      root instanceof Element
    ) {
      elements.push(
        ...root.querySelectorAll(SELECTOR)
      );
    }

    elements.forEach(prepareElement);
  }

  function revealSelectedShopifyBlock(event) {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const titles = [];

    if (target.matches(SELECTOR)) {
      titles.push(target);
    }

    titles.push(
      ...target.querySelectorAll(SELECTOR)
    );

    titles.forEach((title) => {
      title.classList.add(VISIBLE_CLASS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeTitles(document),
      { once: true }
    );
  } else {
    initializeTitles(document);
  }

  /*
    Shopify Theme Editor support
  */
  document.addEventListener(
    'shopify:section:load',
    (event) => initializeTitles(event.target)
  );

  document.addEventListener(
    'shopify:block:select',
    revealSelectedShopifyBlock
  );

  /*
    Motion preference runtime me change ho to handle karega.
  */
  prefersReducedMotion.addEventListener?.(
    'change',
    (event) => {
      document
        .querySelectorAll(SELECTOR)
        .forEach((element) => {
          if (event.matches) {
            observer?.unobserve(element);
            element.classList.add(VISIBLE_CLASS);
          }
        });
    }
  );
})();